import workImg1 from "../assets/images/work/Canadian-product-demonstration-in-Mexico.jpg";
import workImg2 from "../assets/images/work/Custom-packaging-prototyping-and-tests-2.jpg";
import workImg3 from "../assets/images/work/Custom-packaging-prototyping-and-tests-3.jpg";
import workImg4 from "../assets/images/work/Custom-packaging-prototyping-and-tests-4.jpg";
import workImg5 from "../assets/images/work/Custom-packaging-prototyping-and-tests-5.jpg";
import workImg6 from "../assets/images/work/Custom-packaging-prototyping-and-tests-6.jpg";
import workImg7 from "../assets/images/work/Custom-packaging-prototyping-and-tests-7.jpg";
import workImg8 from "../assets/images/work/Custom-packaging-prototyping-and-tests-8.jpg";
import workImg9 from "../assets/images/work/Custom-packaging-prototyping-and-tests-9.jpg";
import workImg10 from "../assets/images/work/Custom-packaging-prototyping-and-tests-10.jpg";
import workImg11 from "../assets/images/work/Custom-packaging-prototyping-and-tests-11.jpg";
import workImg12 from "../assets/images/work/Custom-packaging-prototyping-and-tests-12.jpg";
import workImg13 from "../assets/images/work/Custom-packaging-prototyping-and-tests-13.jpg";
import workImg14 from "../assets/images/work/Labeling-and-automation-1.jpg";
import workImg21 from "../assets/images/work/Labeling-and-automation-2.jpg";
import workImg15 from "../assets/images/work/Labeling-and-automation-3.jpg";
import workImg16 from "../assets/images/work/Labeling-and-automation-4.jpg";
import workImg17 from "../assets/images/work/Labeling-and-automation-5.jpg";
import workImg18 from "../assets/images/work/Labeling-and-automation-6.jpg";
import workImg19 from "../assets/images/work/Labeling-and-automation-7.jpg";
import workImg20 from "../assets/images/work/Labeling-and-automation-8.jpg";
import workImg22 from "../assets/images/work/Visit-at-customer-facility-1.jpg";
import workImg23 from "../assets/images/work/Visit-at-customer-facility-2.jpg";
import workImg24 from "../assets/images/work/Visit-at-customer-facility-3.jpg";
import workImg25 from "../assets/images/work/Visit-at-customer-facility-4.jpg";
import workImg26 from "../assets/images/work/Visit-at-customer-facility-5.jpg";
import workImg27 from "../assets/images/work/Visit-at-customer-facility-6.jpg";
import workImg28 from "../assets/images/work/Visit-at-customer-facility-7.jpg";
import workImg29 from "../assets/images/work/Visit-at-customer-facility-8.jpg";
import workImg30 from "../assets/images/work/Frozen-tuna-from-Mexico-for-sale-in-Canada-1.jpeg";
import workImg31 from "../assets/images/work/Frozen-tuna-from-Mexico-for-sale-in-Canada-2.jpeg";
import workImg32 from "../assets/images/work/Frozen-tuna-from-Mexico-for-sale-in-Canada-3.jpeg";
import workImg33 from "../assets/images/work/Customer-product-at-major-retailers-1.jpg";
import workImg34 from "../assets/images/work/Customer-product-at-major-retailers-2.jpg";
import workImg35 from "../assets/images/work/Customer-product-at-major-retailers-3.jpg";
import workImg36 from "../assets/images/work/Customer-product-at-major-retailers-4.jpg";
import workImg37 from "../assets/images/work/Flowers-from-Mexico-market-trial-in-Canada-1.jpg";
import workImg38 from "../assets/images/work/Flowers-from-Mexico-market-trial-in-Canada-2.jpg";
import workImg39 from "../assets/images/work/Foodservice-1.jpg";
import workImg40 from "../assets/images/work/Foodservice-2.jpg";
import workImg41 from "../assets/images/work/Process-product-flow-1.jpg";
import workImg42 from "../assets/images/work/Process-product-flow-2.jpg";
import workImg43 from "../assets/images/work/Tradeshow.jpg";
import workImg44 from "../assets/images/work/Understanding-customer-needs.jpg";
import workImg45 from "../assets/images/work/logistics-truck.jpg";
import workImg46 from "../assets/images/work/flexible-packaging.jpg";

export interface GalleryImage {
    img: string,
    description: string
};

export const workImgs: GalleryImage[] = [
    {
        img: workImg43,
        description: "Tradeshow"
    },
    {
        img: workImg1,
        description: "Canadian product demonstration in Mexico"
    },
    {
        img: workImg45,
        description: "Logistics"
    },
    {
        img: workImg46,
        description: "Flexible packaging"
    },
    {
        img: workImg2,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg3,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg4,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg5,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg6,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg7,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg8,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg9,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg10,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg11,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg12,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg13,
        description: "Custom packaging prototyping and tests"
    },
    {
        img: workImg14,
        description: "Labeling and automation"
    },
    {
        img: workImg15,
        description: "Labeling and automation"
    },
    {
        img: workImg16,
        description: "Labeling and automation"
    },
    {
        img: workImg17,
        description: "Labeling and automation"
    },
    {
        img: workImg18,
        description: "Labeling and automation"
    },
    {
        img: workImg19,
        description: "Labeling and automation"
    },
    {
        img: workImg20,
        description: "Labeling and automation"
    },
    {
        img: workImg21,
        description: "Labeling and automation"
    },
    {
        img: workImg22,
        description: "Visit at customer facility"
    },
    {
        img: workImg23,
        description: "Visit at customer facility"
    },
    {
        img: workImg24,
        description: "Visit at customer facility"
    },
    {
        img: workImg25,
        description: "Visit at customer facility"
    },
    {
        img: workImg26,
        description: "Visit at customer facility"
    },
    {
        img: workImg27,
        description: "Visit at customer facility"
    },
    {
        img: workImg28,
        description: "Visit at customer facility"
    },
    {
        img: workImg29,
        description: "Visit at customer facility"
    },
    {
        img: workImg30,
        description: "Frozen tuna from Mexico for sale in Canada"
    },
    {
        img: workImg31,
        description: "Frozen tuna from Mexico for sale in Canada"
    },
    {
        img: workImg32,
        description: "Frozen tuna from Mexico for sale in Canada"
    },
    {
        img: workImg33,
        description: "Customer product at major retailers"
    },
    {
        img: workImg34,
        description: "Customer product at major retailers"
    },
    {
        img: workImg35,
        description: "Customer product at major retailers"
    },
    {
        img: workImg36,
        description: "Customer product at major retailers"
    },
    {
        img: workImg37,
        description: "Flowers from Mexico market trial in Canada"
    },
    {
        img: workImg38,
        description: "Flowers from Mexico market trial in Canada"
    },
    {
        img: workImg39,
        description: "Foodservice"
    },
    {
        img: workImg40,
        description: "Foodservice"
    },
    {
        img: workImg41,
        description: "Process product flow"
    },
    {
        img: workImg42,
        description: "Process product flow"
    },
    {
        img: workImg44,
        description: "Understanding customer needs"
    },
];